import React, { ReactElement } from 'react';
import { RowNode } from 'ag-grid-community';

export const CustomTickRenderer = (value: RowNode): ReactElement => {
  return value.data.assignDhcp ? <span>&#x2713;</span> : <></>;
};
